import axios from 'axios';

const withAuth = fn => args => {
  const headers = {};

  const accessToken = localStorage.getItem('access-token');
  if (accessToken) {
    headers['Authorization'] = `Token ${accessToken}`;
  }
  return fn({ ...args, headers });
};

const _request = ({ method, url, data, params, headers }) => {
  const contentType = (data instanceof FormData)
    ? 'multipart/form-data'
    : 'application/json';

  return axios({
    headers: {
      ...headers,
      'Content-Type': contentType,
    },
    method,
    url,
    data,
    params,
  }).then(response => response.data);
};

export const request = withAuth(_request);

export const setErrorResponseHandler = handler => {
  axios.interceptors.response.use(
    function(response) {
      return response;
    },
    function(error) {
      return handler(error);
    },
  );
};



// WEBPACK FOOTER //
// ./src/utils/rest-service.js